/*
 * @author        joseph.murphy@zumper.com
 * @copyright     Copyright (c) 2023, Zumper
 * @description   nr file ported over to nr-utils
 */

export const Setting = {
  APP_HOSTNAME: 'APP_HOSTNAME',
  APP_PROTOCOL: 'APP_PROTOCOL',
  CLIENT_LOGGING: 'CLIENT_LOGGING',
  CODE_VERSION: 'CODE_VERSION',
  DEBUG: 'DEBUG',
  GIT_BRANCH: 'GIT_BRANCH',
  GIT_SHA: 'GIT_SHA',
  IGNORE_CRITICAL_STYLES: 'IGNORE_CRITICAL_STYLES',
  IMAGE_STATIC_CDN_URL: 'IMAGE_STATIC_CDN_URL',
  INTERNAL_VIDEO_CDN_URL: 'INTERNAL_VIDEO_CDN_URL',
  IS_LOCAL_DEV_MODE: 'IS_LOCAL_DEV_MODE',
  IS_ZUMPER_RENTALS: 'IS_ZUMPER_RENTALS',
  MAPBOX_BROWSER_KEY: 'MAPBOX_BROWSER_KEY',
  MAPBOX_STYLE_KEY: 'MAPBOX_STYLE_KEY',
  MAPBOX_BROWSER_KEY_Z4: 'MAPBOX_BROWSER_KEY_Z4',
  MAPS_BROWSER_URL_KVP: 'MAPS_BROWSER_URL_KVP',
  MEDIA_CDN_URLS: 'MEDIA_CDN_URLS',
  MEDIA_CDN_URL: 'MEDIA_CDN_URL',
  OPTIMIZELY_SDK_KEY: 'OPTIMIZELY_SDK_KEY',
  SERVER_BASIC_AUTH_TOKEN: 'SERVER_BASIC_AUTH_TOKEN',
  SERVER_LOGGING: 'SERVER_LOGGING',
  STATIC_CDN_URL: 'STATIC_CDN_URL',
  STATIC_CDN_URLS: 'STATIC_CDN_URLS',
  STORAGE_PREFIX: 'STORAGE_PREFIX',
  TAG_MANAGER_ID_PROD: 'TAG_MANAGER_ID_PROD',
  TAG_MANAGER_ID_TEST: 'TAG_MANAGER_ID_TEST',
}
